import React from 'react';
import { Clock } from 'lucide-react';
import EmployeeTableRow from './EmployeeTableRow';
import TableHeader from './TableHeader';

export default function EmployeeReportTable({ data }) {
    console.log(data)
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <TableHeader />
        <tbody className="bg-white divide-y divide-gray-200">
          {data.map((employee) => (
            <EmployeeTableRow key={employee.employeeId} employee={employee} />
          ))}
        </tbody>
      </table>
    </div>
  );
}